/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PublicBookingConfirmPathParams,
	PublicBookingConfirmRequest,
	PublicBookingConfirmResponse,
} from '../types/PublicBookingConfirm'

/**
 * POST /interview-scheduling/booking/:tokenString/confirm
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::confirm
 */
export async function publicBookingConfirm(
	tokenString: PublicBookingConfirmPathParams['tokenString'],
	data: PublicBookingConfirmRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicBookingConfirmResponse>> {
	return axiosInstance.post(`/interview-scheduling/booking/${tokenString}/confirm`, data, config)
}
